import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import messages from '../messages';

const getTotalActualIncomeColSize = (isHotmaActive, isBankDataRequired) => {
  if (isBankDataRequired) return 7;
  if (isHotmaActive) return 4;
  return 9;
};

export const AltAssetFooter = ({
  totalMarket,
  totalCash,
  totalAssetIncome,
  imputedIncome,
  isHotmaActive,
  isBankDataRequired,
}) => {
  const totalAssetsColSize = isBankDataRequired ? 5 : 3;
  const totalActualIncomeColSize = getTotalActualIncomeColSize(
    isHotmaActive,
    isBankDataRequired,
  );

  return (
    <React.Fragment>
      <div className="row highlighted-footer">
        <div className={`col-xs-${totalAssetsColSize}`}>
          <FormattedMessage {...messages.totalAssets} />
        </div>
        <div className="col-xs-3" style={{ paddingLeft: '30px' }}>
          <FormattedNumber
            value={totalMarket}
            style={{ value: 'currency' }.value}
            currency="USD"
          />
        </div>
        {isHotmaActive ? (
          <div className="col-xs-4" style={{ paddingLeft: '30px' }}>
            <FormattedNumber
              value={totalCash}
              style={{ value: 'currency' }.value}
              currency="USD"
            />
          </div>
        ) : null}
      </div>
      <div className="row highlighted-footer padtop10">
        <div className="col-xs-5">
          <div className="row">
            <div className="col-xs-8">
              {isHotmaActive ? (
                <FormattedMessage {...messages.totalActualIncome} />
              ) : (
                <FormattedMessage {...messages.totalAnnualIncome} />
              )}
            </div>
          </div>
        </div>
        <div className="col-xs-7">
          <div className="row">
            <div className="col-xs-11">
              <div className="row">
                <div
                  className={`col-xs-offset-${totalActualIncomeColSize} col-xs-3`}
                  style={{ paddingLeft: '45px' }}
                >
                  <FormattedNumber
                    value={totalAssetIncome}
                    style={{ value: 'currency' }.value}
                    currency="USD"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Only show this row if hotma is not active */}
      {!isHotmaActive && (
        <div className="row highlighted-footer padtop10">
          <div className="col-xs-5">
            <div className="row">
              <div className="col-xs-8">
                <FormattedMessage {...messages.imputedIncome} />
              </div>
            </div>
          </div>
          <div className="col-xs-7">
            <div className="row">
              <div
                className="col-xs-offset-9 col-xs-3"
                style={{ paddingLeft: '10px' }}
              >
                <FormattedNumber
                  value={imputedIncome}
                  style={{ value: 'currency' }.value}
                  currency="USD"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};
